import React from 'react';
import { isMobile } from '../../../utils/adaptive';
import { getViewport, generateImageUrl } from '../../../utils/webp';
import { CitySelector } from '../../city-selector';
import { TicketsSection, TicketsTopWrapper, TicketsWrapper } from '../styles/tickets.style';
import { RTE } from '../../../utils/atoms';
import { FooterModal } from '../../footer-modal';

/**
 * Title Component
 * @param {object} props Incoming props
 * @returns {XML} A title component
 */
class Tickets extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.toggleModal = this.toggleModal.bind(this);
    this.state = {
      isMobileLocal: false,
      viewportWidth: 2400,
      modalOpen: false,
    };
  }

  /**
   * Set viewport width on mount
   */
  componentWillMount() {
    if (typeof window !== 'undefined' && window) {
      this.setState({ viewportWidth: getViewport() });
    }
  }

  /**
   * Determine if mobile components should be used
   */
  componentDidMount() {
    if (isMobile()) {
      this.setState({ isMobileLocal: true });
    }
  }

  /**
   * Toggle modal state
   */
  toggleModal() {
    const { modalOpen } = this.state;
    this.setState({
      modalOpen: !modalOpen,
    });
  }

  /**
   * renders component
   * @returns {JSX} JSX for component
   */
  render() {
    const {
      background,
      copy,
      includeSelector,
      subtitle,
      teams,
      enableModal,
      modalTitle,
      modalContent,
      ticketMasterLink,
      ticketMasterButtonText,
    } = this.props;
    const {
      isMobileLocal, viewportWidth, modalOpen,
    } = this.state;
    const html = copy && copy.childMarkdownRemark && copy.childMarkdownRemark.html;
    const backgroundImage = background && background.file && background.file.url ? background.file.url : null;
    const ticketTeams = teams && teams.edges.filter(team => !!team.node.ticketMasterLink);

    const showSectionBackground = !isMobileLocal || (isMobileLocal && !includeSelector);
    return (
      <TicketsSection id="tickets" src={showSectionBackground ? generateImageUrl(backgroundImage, viewportWidth) : ''}>
        {modalOpen && enableModal && <FooterModal title={modalTitle} close={this.toggleModal} content={modalContent} />}
        <TicketsWrapper>
          <TicketsTopWrapper img={!showSectionBackground && backgroundImage}>
            <img className="header-img" src="/images/tickets-header.png" alt="Tickets" />
            <h2 className="subtitle">{subtitle}</h2>
            <RTE
              className="description"
              dangerouslySetInnerHTML={{
                __html: html,
              }}
            />
            {enableModal && (
              <button className="modal-toggle" onClick={this.toggleModal} type="button">
                { 'Season Ticket Deposit Agreement' }
              </button>
            )}
          </TicketsTopWrapper>
          {includeSelector && (
            <CitySelector
              teams={ticketTeams}
              ticketSelector
            />
          )}
          { !includeSelector && ticketMasterLink && (
            <div className="column column-reserve">
              <a href={ticketMasterLink} rel="noopener noreferrer" target="_blank" className="reserveButton">
                {ticketMasterButtonText || 'Reserve'}
              </a>
            </div>
          )}
        </TicketsWrapper>
      </TicketsSection>
    );
  }
}

export default Tickets;



// WEBPACK FOOTER //
// ./src/components/tickets/components/tickets.js